import React, { useEffect } from "react"

function RelativeScroll({ scrollClassName }) {
  useEffect(() => {
    const timeContents = Array.from(document.getElementsByClassName(scrollClassName))

    if (timeContents.length < 2) return

    const syncScroll = (source, target) => {
      target.scrollTop =
        (source.scrollTop / (source.scrollHeight - source.clientHeight)) *
        (target.scrollHeight - target.clientHeight)
    }

    const handleScroll = (index) => {
      timeContents.forEach((timeContent, i) => {
        if (i !== index) {
          syncScroll(timeContents[index], timeContent)
        }
      })
    }

    timeContents.forEach((timeContent, index) => {
      timeContent.addEventListener("scroll", () => handleScroll(index))
    })

    return () => {
      timeContents.forEach((timeContent, index) => {
        timeContent.removeEventListener("scroll", () => handleScroll(index))
      })
    }
  }, [scrollClassName])

  return null
}

export default RelativeScroll
